module.exports = __webpack_public_path__ + "img/9788992036320.a7c1fba7.jpg";